/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useState } from 'react';
// import { NotificationManager } from 'react-notifications';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { setStorage, validateEmail } from '../../utils/auth-utils';
// import { VisibilityIcon, VisibilityOffIcon } from '../../assets/icons';
import { InboundContext } from '../../context/InboundContext';
import { Button, Heading, Text } from '../../components/styledComponents';
import { FormGroup, Logo } from '../../components/common';
import PoweredbySaral from '../../assets/images/powered-by-saral.svg';
import styles from '../../styles/login.module.css';
import { loginCreator } from '../../services/dashboard.service';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  // const [showPassword, setShowPassword] = useState(false);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const { inboundData } = useContext(InboundContext);
  const { search } = useLocation();

  const signInUser = async (e: any) => {
    e.preventDefault();

    if (!validateEmail(email)) {
      setErrorMessage('Invalid Email');
    } else {
      const body = { email, password };
      setDisableSubmitButton(true);
      const response = await loginCreator(body);
      if (response.status) {
        toast.success('Logged in Successfully!');
        setStorage('token', response.data.accessToken);
        setTimeout(() => {
          const searchParam = new URLSearchParams(search);
          const next = searchParam.get('next');
          if (next?.length) {
            window.open(`${window.location.origin}${next}`);
          } else {
            window.location.reload();
          }
          setDisableSubmitButton(false);
        }, 1000);
      } else if (response.message === 'Login blocked. Please contact the brand for more information.') {
        toast.error(response.message);
      } else {
        setErrorMessage('Invalid Credentials');
        setDisableSubmitButton(false);
      }
    }
    setDisableSubmitButton(false);
  };

  return (
    <div className={styles.loginMainDiv}>
      <div className={styles.loginForm}>
        {inboundData?.landingPage?.images?.logo ? (
          <Logo logoUrl={inboundData?.landingPage?.images?.logo} />
        ) : (
          <Logo logoUrl="https://saral-docs-prod.s3.amazonaws.com/Saral+Black+Logo.svg" />
        )}
        <Heading as="h2" fontSize="32px" textAlign="center">
          Login to your ambassador account
        </Heading>
        <form onSubmit={signInUser}>
          <FormGroup
            id="email"
            name="email"
            type="email"
            label="Email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setErrorMessage('');
            }}
          />
          <FormGroup
            id="password"
            name="password"
            // type={showPassword ? 'text' : 'password'}
            type="password"
            label="Password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setErrorMessage('');
            }}
          />
          <div className={styles.labelDiv}>
            <label htmlFor="remember-me" className={styles.checkbox}>
              <input type="checkbox" id="remember-me" />
              Remember me
            </label>
            <a href="/dashboard/forgot-password"> Forgot Password</a>
          </div>
          <div className={styles.labelDiv}>{errorMessage && <Text color="#e64848">{errorMessage}</Text>}</div>
          <Button width="100%" disabled={!email || !password || disableSubmitButton} type="submit">
            Login
          </Button>
        </form>
        {/* <Text>
          Need Help? <Link to="/">Contact us</Link>
        </Text> */}
      </div>
      <a href="https://getsaral.com" target="_blank" rel="noreferrer">
        <img src={PoweredbySaral} alt="powered by Saral" className={styles.poweredBySaral} />
      </a>
    </div>
  );
}
